// extracted by mini-css-extract-plugin
export default {"approveBtn":"styles_approveBtn__wOMOT","rejectBtn":"styles_rejectBtn__ZBrJ7","inactiveBtn":"styles_inactiveBtn__--aIO"};